export enum DiscountType {
  Amount = 'Amount',
  Percentage = 'Percentage',
}
